<div class="client-list-component">
  <div class="col-md-12 no-padding">
    <legend>Clients</legend>
    <div class="trips-tab-body">
      <lgt-grid-static
        [cols]="colsClients"
        [data]="clientList"
        [selectCol]="true"
        [onDblClick]="viewDetail"
        [showPrintInvoice]="false"
        [showNewButton]="true"
        [newButtonOptions]="newButtonOptions"
        [newButtonAction]="newButtonAction"
        [filters]="filters"
        [loadData]="loadData"
        [showExcelButton]="true"
        [onExcelButton]="excelGeneration"
        [useSignalR]="false"
        [pageName]="'client-list'"
      />
    </div>
  </div>
</div>